import CompanyRequestModelBase from '../_generated/modelBases/company-request-model-base';

export default class CompanyRequestModel extends CompanyRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
